var BusinessUnit = /** @class */ (function () {
    function BusinessUnit(props) {
        if (props) {
            Object.assign(this, props);
            this.image = props.image + '?dummy=' + makeid(3);
        }
    }
    return BusinessUnit;
}());
export default BusinessUnit;
export var makeid = function (length) {
    var result = '';
    var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    var charactersLength = characters.length;
    for (var i = 0; i < length; i++) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
};



//////////////////
// WEBPACK FOOTER
// ./src/modules/BusinessUnits/Model.ts
// module id = 324
// module chunks = 0